var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2000",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,454)",
    d: "m0 0 4 1 9 7 13 11 11 9 14 11 18 14 14 11 15 11 17 9 2 4 1 11 5 2 9 6 16 13 16 12 28 17 24 13 20 12 24 16 19 14 10 8 13 11 10 9 8 8 4 3v2h2l7 8 14 15 9 11 15 20 16 24 11 19 12 23 12 28 9 27 8 29 4 19 4 33 2 21 1 19v16l-2 32-5 49-8 43-9 29-11 27-8 17 29-12 14-7 7-8 8-16 9-21 7-23 4-18 5-36 2-34v-24l-2-29-6-45-2-12v-8l11-4 5 1 2 7 2 9 3 3 6 4 6 10 7 19 8 27 13 50 10 40 13 50 19 76 2 11v15l-4 10-6 8-8 6-12 5-16 1-102 1 25 45v2l-2 1-16 1h-83l-8 7-9 8-15 11-3 1-8-7-7-8-12-13-3-1-54-2-6-5-15-27-13-22-4-5-14 14-15 11-14 9-16 9-16 8-19 8-25 8-27 6-27 4-11 1h-42l-21-2-30-5-31-8-30-10-27-11-29-14-8-3-2 5-8 11-13 21-9 16-6 8-2 2h-27l-6-2 1-5 6-17-6-2-15-6-21-7-50-13-21-4-5 1-4 5v2l14 8 12 11 14 15 10 10 11 9 13 11 24 16 19 12 14 8 33 15 21 8 37 12 37 9 36 6 18 2 42 3 44 1 31-1 59-5 51-8 32-12 35-15 27-12 20-11 4-2h6l4 4 1 9-5 6-11 3-24 14-22 11-14 6-36 14-14 5-6 3-26 6-29 4-30 2h-70l-34-3-25-3-40-8-34-9-25-8-25-9-49-19-36-16-23-11-18-10-18-12-16-12-14-12-22-22-8-7-5-5-5-2-7 3-16 3-14 1-3-1 1-6 7-12 5-12-5-5-11-10-13-13-12-17-8-18-5-19-2-10-1-11v-12l2-19 5-24 8-21 8-16 11-18 10-12v-15l-3-36v-34l4-49 7-31 5-18 8-22 10-24 8-17 12-20 8-12 10-14 11-13 9-11 6-7 20-20 8-7 15-13 13-10 23-16 24-14 17-9 21-9 24-9 19-6 24-7 21-4h5l2-22 5-45 1-8 2-1 16-1h55l40 2-7-37-5-27zm118 113-1 3 8 25 6 10 10 9 20 12 14 7 20 12 21 14 32 24 13 11 16 15 30 30 7 8 11 13 15 20 9 14 9 16 8 14 12 26 10 27 9 29 6 28 3 24 2 27v41l-2 27-4 27-9 38-9 30-4 12 4 7 5 5 4-1 7-10 8-17 8-24 7-29 6-44 1-13v-66l-2-21-6-40-9-32-8-21-16-36-10-19-11-18-15-22-11-14-9-11-12-14-9-9-7-8-15-14-13-11-13-10-17-12-21-13-26-15-25-14-21-14-10-8-10-9-10-11-5-5z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,454)",
    d: "m0 0 4 1 9 7 13 11 11 9 14 11 18 14 14 11 15 11 17 9 2 4 1 11 5 2 9 6 16 13 16 12 28 17 24 13 20 12 24 16 19 14 10 8 13 11 10 9 8 8 4 3v2h2l7 8 14 15 9 11 15 20 16 24 11 19 12 23 12 28 9 27 8 29 4 19 4 33 2 21 1 19v16l-2 32-5 49-8 43-9 29-11 27-8 16-3-1-15-27v-5l7-8 8-16 5-12 6-18 7-29 6-44 1-13v-66l-2-21-6-40-9-32-8-21-16-36-10-19-11-18-15-22-11-14-9-11-12-14-9-9-7-8-13-12-14-12-13-10-17-12-21-13-26-15-25-14-21-14-10-8-10-9-11-12-4-4-1 2 8 25 6 10 9 8 20 12 14 7 20 12 21 14 32 24 13 11 16 15 31 31 7 8 11 13 15 20 9 14 9 16 8 14 12 26 10 27 9 29 6 28 3 24 2 27v41l-2 27-4 27-9 38-9 30-4 10-4-5-6-9-10-16-9-13-22-36-17-28-10-15-9-17-12-19-17-28-9-14-11-17-14-22-9-16-10-18-8-12-9-15-13-21-13-22-12-20-7-10-12-21-8-16-12-21-20-32-13-22-12-21-14-23-6-9-8-14-11-18-8-14-3-1-2 5-15 23-7 11-8 12-7 10-8 13-10 19-16 25-11 17-7 10-14 23-26 42-8 13-13 21-12 19-11 17-13 20-14 21-12 19-12 22-13 20-8 11-12 19-15 24-13 21-9 13-10 18-11 17-12 19-11 17-18 26-10 15-14 22-8 15-12 18-7 10-21 32-10 15-5 7-4-2-10-8-6-5-7-8-8-9-9-14-7-16-5-19-2-10-1-11v-12l2-19 5-24 8-21 8-16 11-18 10-12v-15l-3-36v-34l4-49 7-31 5-18 8-22 10-24 8-17 12-20 8-12 10-14 11-13 9-11 6-7 20-20 8-7 15-13 13-10 23-16 24-14 17-9 21-9 24-9 19-6 24-7 21-4h5l2-22 5-45 1-8 2-1 16-1h55l40 2-7-37-5-27z",
    fill: "#153668"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,634)",
    d: "m0 0 4 2 15 27 8 13 8 16 7 12 10 15 30 52 12 19 7 10 13 23 8 16 11 19 10 16 10 15 10 17 13 22 15 24 7 10 9 17 11 18 13 21 12 19 10 15 12 20 7 11 6 10 8 16 10 16 8 12 11 18 10 17 13 21 11 18 11 17 12 23 11 19 1 3-1 1h-146l-4-5-13-23-24-42-7-13-11-19-10-17-14-23-10-15-9-15-12-21-14-27-12-19-13-21-7-12v-2h67l3-1-27-1-45-1-6-9-8-14-12-19-9-15-8-14-8-17-15-25-9-13-4-6-1-3-2-1-2 6-8 14-10 16-16 29-12 23-7 11-2 2h-27l-114-1 7-11 11-18 10-15 14-22 9-14 7-10 7-11 7-13 11-18 14-23 14-21 11-17 16-26 13-22 7-13 7-10 10-16 14-23 12-19z",
    fill: "#EE7B27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,995)",
    d: "m0 0h84l4 4 15 26 15 24 9 15 10 17 12 20 16 27 12 22 9 15 8 13 13 21 8 12 8 13 11 18 2 5-1 3-7 6-8 8-15 11-14 9-16 9-16 8-19 8-25 8-27 6-27 4-11 1h-42l-21-2-30-5-31-8-30-10-27-11-29-14-8-3 2-5 9-15 16-26 10-16 9-13 15-24 11-18 6-10 8-16 11-16 15-25 11-18 17-28 10-15 12-22 5-12z",
    fill: "#175289"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,454)",
    d: "m0 0 4 1 9 7 13 11 11 9 14 11 18 14 14 11 15 11 17 9 2 4 1 11 5 2 9 6 16 13 16 12 28 17 24 13 20 12 24 16 19 14 10 8 13 11 10 9 8 8 4 3v2h2l7 8 14 15 9 11 15 20 16 24 11 19 12 23 12 28 9 27 8 29 4 19 4 33 2 21 1 19v16l-2 32-5 49-8 43-9 29-11 27-8 16-3-1-15-27v-5l7-8 8-16 5-12 6-18 7-29 6-44 1-13v-66l-2-21-6-40-9-32-8-21-16-36-10-19-11-18-15-22-11-14-9-11-12-14-9-9-7-8-13-12-14-12-13-10-17-12-21-13-26-15-25-14-21-14-10-8-10-9-11-12-4-4-1 2 8 25 6 10 9 8 20 12 14 7 20 12 21 14 32 24 13 11 16 15 31 31 7 8 11 13 15 20 9 14 9 16 8 14 12 26 10 27 9 29 6 28 3 24 2 27v41l-2 27h-1v-5l-4 2-4 4-4 1-9 1-3-2-6-2-6-4-1-3-4-2-5-6-2-7-1-15-1-41-3-32-4-18-5-16-6-16-7-12-3-6-9-11v-3l-4-1v-3l-4-1-2-4h-2v-4l-7-1-1-2-14 7-5 1-1 2h-3l-1 6-6 14-6 4-2-1-3-2 1 3-3 1 7 2h3v2l-8-1-8-4-5-4-5-3-8-5-8-7-6-8-8-11-6-8-8-13v-2h-2l-6-8v-2h-2l-4-8-5-8-8-15-8-17-7-12-10-22-5-8-3-7v-3h-2l-3-9-7-15-5-11-10-19-6-12-9-17-9-14-6-8-5-9-4-6v-2h-2l-6-8-2-1v-2h-2l-10-21-6-9-8-10v-2h-2v-2l-4-2-6-4-1-5-6-1-1-3-2-1v5h-1l-7-38-4-23z",
    fill: "#15B7E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(887,536)",
    d: "m0 0h1l1 6 3 1v2l1-2h4v5h9l6 8 4 10 2 7-2 11-3 12 2 1-2 8-1 13-3 7-2 17-2 5-2 8-8 14-1 3-2 1-3 9-2 8-5 18-2 14-3 22-3 10h-2l-1 4-5 9-2 1v3l-5 5h-2l-1 6-4 3h-2l-2 5-10 10-2 3h-2v2l-3 3h-2l-2 5-9 11-7 7-9 11-13 11-2 3h-2v2l-6 3-6 4v2l-6 3h-2l-3 3-1 3-3 1-3 5-3 1h-2l-9 7-7 6-2 4-8 6-7 7-6 3-6 5-6 3h-2v2l-11 6-5 3-16 8-10 3-1 1h-8l-7-2-3-4v-27l5-29 4-20 4-13 3-12v-8l-2-1-9 2v2l-10 7-7 8-7 9-9 15-4 8-6 17-8 25-5 25-4 25-3 20-3 14-1 8-2 2-2 6-5 1v-2h-2l-2-7-4-6-3-3v-2h-3l-1-6h-2v-34l4-49 7-31 5-18 8-22 10-24 8-17 12-20 8-12 10-14 11-13 9-11 6-7 20-20 8-7 15-13 13-10 23-16 24-14 17-9 21-9 24-9 19-6 24-7 21-4h5l2-22z",
    fill: "#17538A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,995)",
    d: "m0 0h91l48 1-2 5-12 20-12 19-6 8-14 23-6 10-7 14-15 24-10 14-14 22-12 20-16 25-10 16-8 15-12 19-14 23-10 15-9 12-8 13h-2l-1 2-15-7-27-9-50-13-21-4-9-1-1-2 20-34 9-17 12-17 6-8 10-15 13-20 26-39 7-9 7-13 16-24 26-40 10-14 10-16 10-15z",
    fill: "#153668"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 660)",
    d: "m0 0h5l1 2h11v-2l7 2 6 8 3 6 4 4 6 16 12 18 4 4 8 19 3 6v6l1 5 3 1 3 9 1 7 3 6v10l1 3-3 5-4 2h-5l-4-1-6-1-1 5-4 8-5 9-7 11-2 1-1 8v46l3 12 1 5-4-2v-3h-2l1 4 3 6 3 9v3l5 2v3l2 1 5 4 3 2 3 7 5 3 5 8v2h2v2h2l7 10 4 8 3 8 3 3 2 7h2l3 9h-14l-3-1-12-21-12-19-9-15-8-14-8-17-15-25-9-13-4-6-1-3-2-1-2 6-8 14-10 16-16 29-12 23-7 11-2 2h-27l-114-1 7-11 11-18 10-15 14-22 9-14 7-10 7-11 7-13 5-5 20-32 13-20 4-5 4-7 4-5 6-11 6-9 1-3h2l2-5 6-11 6-9 6-12 2-3h2l2-4 6-11 4-5 2-1 2-6 7-10 4-4 2-4z",
    fill: "#F06221"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,995)",
    d: "m0 0h84l4 4 15 26 15 24 9 15 10 17 12 20 16 27 12 22 9 15 8 13 13 21 8 12 8 13 11 18 2 5-1 3-7 6-8 8-15 11-14 9-16 9-16 8-19 8-25 8-27 6-27 4-11 1h-42l-21-2-30-5-31-8-30-10-27-11-29-14-8-3 2-5 9-15 16-26 10-16 9-13 15-24 11-18 6-10 8-16 11-16 15-25 11-18 17-28 10-15 12-22 5-12zm45 14-18 1-12 2-4 2-9 2-7 6-5 5-5 8v2h-2l-4 4-3 7-3 3v4l-3 1-2 4-3 3-1 5-5 5-3 7-2 2-2 6-3 3-2 5-7 12-3 3v4h-2l-2 6-2 1-3 6-5 11-1 6-1 4 1 4h2l-1 7v17l1 8 1 7 4 15 10 8 7 3 2 3 8 2 8 3 14 3 1 1 9 2 14 5 7 2h38l17-2h17l8-1 11-3 16-3 16-1 7-2 4-2 8-2 9-5 5-3 5-7 11-5 5-9 1-11-5-12-4-9-5-11-6-11-11-21-12-20-3-4-6-11-6-9-5-10h-2l-2-6-8-14h-2l-1-5-4-5-4-7-9-12-10-6v2l-3-2h-16z",
    fill: "#163668"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 514)",
    d: "m0 0 3 1v2l6 2 3 6 8 5v2h2l10 13 6 10 8 17v2h2v2l4 2 4 5v2h2l5 8 7 12 6 8 7 11 10 19 8 16 7 13 5 11 5 10 4 11v3h2l5 12 5 9 11 23 6 10 10 21 9 16 4 6v3h2l6 8v2h2l11 18 8 10 4 6 6 8 8 7 8 5 11 7 9 4 5 1v-2l-4 1-7-3 3-2v-2l4 1h2l5-2 3-9 4-11h3l1-3 10-3 10-5v3l7 1 2 3 2 2v3l4 1 1 3 3 1 4 7 7 8 6 12 4 7 6 17 4 13 4 18 3 32 1 44 2 17 7 9 6 5 4 3 7 2 2 1 10-1 5-2 1-3 4-1v14l-4 23-10 40-9 29-2 4-4-5-6-9-10-16-9-13-22-36-17-28-10-15-9-17-12-19-17-28-9-14-11-17-14-22-9-16-10-18-8-12-9-15-13-21-13-22-12-20-7-10-12-21-8-16-12-21-20-32-13-22-12-21-14-23-6-9-8-14-11-18-8-14-3-1 1-6-5-13-3-10-4-7v-8h-7v-1h8l-1-4z",
    fill: "#17538A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1481,911)",
    d: "m0 0 5 1 2 7 2 9 3 3 6 4 6 10 7 19 8 27 13 50 10 40 13 50 19 76 2 11v15l-4 10-6 8-8 6-12 5-16 1h-102l-7-10-10-18-14-22-2-5 28-12 14-7 7-8 8-16 9-21 7-23 4-18 5-36 2-34v-24l-2-29-6-45-2-12v-8z",
    fill: "#EE7B28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,454)",
    d: "m0 0 4 1 9 7 13 11 11 9 14 11 2 3-6-1 4 17 7 16 3 8 5 11 6 15 6 12 8 15 16 32 10 19 6 10 6 11 8 12 1 3h2l14 14 8 10 7 9 6 6h6l1-8 5-5 2-7 5-1v-2h7l6 3 1 2 7 4 10 8 11 9v2l3 1 5 5 13 12 7 8 1 3h2l9 11 13 16 13 18 10 15 5 10 10 18 11 23 8 20 8 26 6 28 5 36 2 9 1 6h2l7 8 6 5 12 4h5l6-5 3-5h2l1-3h1v54l-1 10h-1v-5l-4 2-4 4-4 1-9 1-3-2-6-2-6-4-1-3-4-2-5-6-2-7-1-15-1-41-3-32-4-18-5-16-6-16-7-12-3-6-9-11v-3l-4-1v-3l-4-1-2-4h-2v-4l-7-1-1-2-14 7-5 1-1 2h-3l-1 6-6 14-6 4-2-1-3-2 1 3-3 1 7 2h3v2l-8-1-8-4-5-4-5-3-8-5-8-7-6-8-8-11-6-8-8-13v-2h-2l-6-8v-2h-2l-4-8-5-8-8-15-8-17-7-12-10-22-5-8-3-7v-3h-2l-3-9-7-15-5-11-10-19-6-12-9-17-9-14-6-8-5-9-4-6v-2h-2l-6-8-2-1v-2h-2l-10-21-6-9-8-10v-2h-2v-2l-4-2-6-4-1-5-6-1-1-3-2-1v5h-1l-7-38-4-23z",
    fill: "#0E80B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,579)",
    d: "m0 0 5 1-2 8-2 7-11 17-8 12-7 10-8 13-10 19-16 25-11 17-7 10-14 23-26 42-8 13-13 21-12 19-11 17-13 20-14 21-12 19-12 22-13 20-8 11-12 19-15 24-13 21-9 13-10 18-11 17-12 19-11 17-18 26-10 15-14 22-8 15-12 18-7 10-21 32-10 15-5 7-4-2-10-8-6-5-3-4 1-4 3-1-1-5-3-5 2-6 1-11 4-5 2-6 1-1 2-15 7-12 6-8 3-5 5-5 4-7 3-4 7-18 8-10 3-8 8-16 6-5 1-4 4-3h2l2-6 4-2 1-3 4-3h2l4-8h-2v-4l5-5 4-7 5-5 6-3 7-3 5-3 11-9 9-10 5-5 10-8 1-2 5-3 3-6 6-4 4-6 4-1-6 9 4-5 8-7 12-21 5-6h2l1-4 3-1 2-6h-2l1-4 3-3h3 2v-2l7-6 3-3 2-5h2l2-6 7-10 3-7h2l2-5 2-4h3v-3h2l2-4 7-9h2l2-4 3-5 4-5 1-2h2l2-4 7-9 2-2 2-6 5-6 8-17h2l1-4 1-2h2l2-4 3-3 4-8 4-4 3-6 6-3 1-8 2-8 5-9 8-13h2l2-5h2l2-4 3-9 2-3 2-6 5-5 7-13 3-6 3-1 2-7h2v-3l3-3 10-17 4-8h2l2-7 3-6h2v-5h2l2-5 3-7 4-3 6-12 7-10h2v-2h2l1-4 6-8z",
    fill: "#0F2B59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,1006)",
    d: "m0 0 7 1 7 3 3 2v2l7 1 5-1 11 4 5 5 3-1 3 4-1 5-3 9-2 1-2-1-2 6-3 8-5 2-2 6-4 5h-2l-2 4-3 3-2 4-7 11-4 4-2 6h-2v2h-2l-2 5-5 5-5 6-4 6-11 14-11 11-5 6-3 3-3 6-4 4-5 7-4 9-9 16-8 14-7 8-3 7-5 7-5 5-9 10-3 4h-2l-2 7-6 5-3 13-5 2v7l1 4-8-1-29-7-21-3-1-2 20-34 9-17 12-17 6-8 10-15 13-20 26-39 7-9 7-13 16-24 26-40 10-14 5-8 1 2h2l2-4h3l1-6h2v-2h2l1-2z",
    fill: "#17538A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,554)",
    d: "m0 0 6 2 11 8 17 14 17 12 24 14 29 16 24 15 20 14 21 16 14 12 10 9 8 8 4 3v2h2l7 8 14 15 9 11 15 20 16 24 11 19 12 23 12 28 9 27 8 29 4 19 4 33 2 21 1 19v16l-2 32-5 49-8 43-9 29-11 27-8 16-3-1-15-27v-5l7-8 8-16 5-12 6-18 7-29 6-44 1-13v-66l-2-21-6-40-9-32-8-21-16-36-10-19-11-18-15-22-11-14-9-11-12-14-9-9-7-8-13-12-14-12-13-10-17-12-21-13-26-15-25-14-21-14-10-8-10-9-11-12-3-3-2-5z",
    fill: "#17558B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,930)",
    d: "m0 0h40l-2 5-14 25-9 23-10 33-7 27-8 35-7 36-3 31v30l3 21 4 11 7 12 8 10 8 7 5 4 1 4-12 3-28 3h-29l-12-3-3-3v-9l5-37 6-45 12-86 7-44 10-61 5-25 3-5 2-1z",
    fill: "#16386A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,494)",
    d: "m0 0 7 1 11 9 17 13 13 10 16 9 4 2 2 4 1 11 2 1-1 10 1 4h-2l2 8 6 19 6 10 9 8 20 12 14 7 20 12 21 14-1 4 3 5-5-2-8-6-8-5-3-1v-2h-3v-2l-4-1-4-2-2-2-2-1v-2l-12-6h-6l-2 5-2 10 5 5 1 4 5 5 8 6 2 1v2l4 1 4 3v2l4 1 8 6 3 1v2l5 2 18 15 3 2 10 9v2l4 2 8 7 5 6 5 5 4 5v2l3 1 10 13 8 10 7 11 8 10 8 13 10 18 8 15 12 24 6 16 6 19 5 22 9 26 6 6 13 4 10-3 3-1 1-5h2v-2h2l-1-2-1-23v-7l2 4 4 19 3 24 2 27v41h-1l-1-36-1 2h-2l-2 5-3 1-1 3-3 2-9-1-9-4-8-7-4-4v-2h-2l-3-8-1-7-5-36-6-28-9-29-13-30-14-27-4-7-9-15-11-15-13-17-13-15v-2h-2l-14-16-8-7-7-6v-2l-4-2-10-9-11-8-4-2v-2l-6-2-7-1v2l-5 1-1 7-4 2-3 11-6 1-10-10-6-8-9-11-10-9v-2h-2l-12-18-18-33-8-15-9-20-3-5-6-11-6-12-9-21-3-8-6-13-5-16-2-9z",
    fill: "#11A4D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1291)",
    d: "m0 0h13l13 8 10 9 15 16 10 10 11 9 13 11 24 16 19 12 14 8 33 15 21 8 37 12 37 9 36 6 18 2 42 3 44 1 31-1 59-5 51-8 32-12 35-15 27-12 20-11 4-2h6l4 4 1 9-5 6-11 3-24 14-22 11-14 6-36 14-14 5-6 3-26 6-29 4-30 2h-70l-34-3-25-3-40-8-34-9-25-8-25-9-49-19-36-16-23-11-18-10-18-12-16-12-14-12-22-22-8-7-9-9 1-5z",
    fill: "#15396B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1481,911)",
    d: "m0 0 5 1 2 7 2 9 3 9 6 40 3 25 2 30v53l-2 26-3 20-5 21-5 13-14 7-27 11-4-1 10-19 8-19 7-23 4-18 5-36 2-34v-24l-2-29-6-45-2-12v-8z",
    fill: "#163769"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1088 1e3)",
    d: "m0 0 8 1 50 1 7 1v1l-12 1-5 5-1 12v10l3 10 2 10 5 4 2 10 5 8 6 11 6 10 6 11 8 13 9 11 1 4h2l8 14 5 8 8 15 3 6 7 10 10 19 4 5 12 24 3 5v2l3 1v2l3 1 9 14 1 3-1 5-6 3h-10l-7-10-8-14-5-10-4-7-14-24-2-1-2-6-2-1-2-6-4-2-13-23-13-22-12-19-11-17-12-21-12-22-9-17-11-17-18-30z",
    fill: "#C36321"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1037)",
    d: "m0 0h15l10 4v2l5 2 7 6 9 16v2h2l2 9 3 4 1 5v11l-1 2 1 3-4 3h-2l-1 4-2 1h-8l-12 4-13 4-14 1-18-1-7-4-6-1-3-3-3-1v-20l2-8 2-6 2-8 4-8 7-11 10-8z",
    fill: "#0E80B4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,850)",
    d: "m0 0 7 1 1 4h5l5-2 2 7 7 12 5 6v2l6 1 4 4h2v-2l4 2 4 5 3 7-1 3-2-2-1-3h-2l1 4 3 6 3 9v3l5 2v3l2 1 5 4 3 2 3 7 5 3 5 8v2h2v2h2l7 10 4 8 3 8 3 3 2 7h2l3 9h-14l-3-1-12-21-12-19-9-15-8-14-8-17-15-25-9-13-4-6-1-3-2-1-2 6-8 14-10 16-16 29-12 23-7 11-2 2h-27l-45-2v-1l36-1 3-3 1-6-1-2 4-9 5-5 7-8 1-3 3-2 4-8 3-1 2-6 3-1 1-4 1-2h2l3-10 2-1 5-10 8-11 2-3 4-2 5-5h2v-2l4-2h4z",
    fill: "#C26321"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,995)",
    d: "m0 0h91l48 1-2 5-12 20-12 19-6 8-14 23-6 10-7 14-15 24-10 14-14 22-12 20-16 25-10 16-8 15-12 19-14 23-10 15-9 12-4 2-6 8h-5v-4l3-3 3-11 8-14h2l2-5 3-8h2l2-5 3-5 4-9 2-3 3-9 2-5 5-5 1-2h2l2-4 6-8 5-4 2-7 3-4 4-2 1-3h2l2-4 3-9 1-5 6-9 5-8 4-9 1-2h2l7-10h2l1-4 4-6 6-4 2-4h2l2-6 5-5 6-16 5-9 2-3 1-4h2l6-12h2l2-8h2v-3h2l1-4 3-1 1-4 8-14 1-7v-7l2-1 1-2-6-2-7-2-4-1-17-1-13-1-17-3-26-2h-19z",
    fill: "#0F2D5B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1179,999)",
    d: "m0 0h8l2 1-1 3-27 2h-2l-1 8v9l-2 4v18l1 8 3 4 5 13 7 14 6 9v3h2l7 16 11 16 7 10 7 12 7 14 6 11 3 5v2h2l5 10 8 11 7 8 6 11 7 9 1 3 4 4 8 17 3 10v4l-4 2 13 1v1l-39 1-5-4-13-23-24-42-6-11v-2l3 1 1 6 3 1 1 6 3 1 14 24 5 9 12 22 6 9h10l6-2v-7l-6-8-4-7-5-4-9-16-5-12-7-10-9-17-8-11-8-16-6-11-8-13v-2h-2l-4-6-7-9-8-13-7-12-5-9-7-12-4-7-2-10-5-4-3-15-2-5v-12l1-10 4-2 2-4 5-1v-1l30-1z",
    fill: "#D77025"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,1050)",
    d: "m0 0 2 1 3 2 3 1v2l4-1 2-2v12l-4 33-7 37-9 29-11 27-8 16-3-1-15-27v-5l7-8 8-16 5-12 6-18 7-29 2-15 2-6 3 1 3-2 2 1 1-8-1-8-4-2z",
    fill: "#15396B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1291)",
    d: "m0 0h13l13 8 10 9 15 16 10 10 11 9 13 11 24 16 19 12 14 8 33 15 21 8 12 4-4 1-3-1v6l-17-6-30-12-29-13-23-11-18-10-18-12-16-12-14-12-22-22-8-7-9-9 1-5z",
    fill: "#153A6C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1264,1380)",
    d: "m0 0h6l4 4 1 9-5 6-11 3-24 14-22 11-14 6-36 14-13 4-6-17 2-2 32-12 35-15 27-12 20-11z",
    fill: "#EE7C28"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,579)",
    d: "m0 0 5 1-2 8-2 7-11 17-8 12-7 10-8 13-10 19-16 25-11 17-7 10-14 23-13 21-12 19-2-4 2-12 6-11 8-13h2l2-5h2l2-4 3-9 2-3 2-6 5-5 7-13 3-6 3-1 2-7h2v-3l3-3 10-17 4-8h2l2-7 3-6h2v-5h2l2-5 3-7 4-3 6-12 7-10h2v-2h2l1-4 6-8z",
    fill: "#0F2F5E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1139,1433)",
    d: "m0 0h5l4 10 2 8-4 3-24 6-25 4-39 3h-15v-1l14-1 5-3h2l1-5 1-10h-2v-2h-14v-1l53-5z",
    fill: "#12A4D7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,850)",
    d: "m0 0 7 1 1 4h5l5-2 2 7 7 12 5 6v2l6 1 4 4h2v-2l4 2 4 5 3 7-1 3-2-2-1-3h-2l1 4 3 6 3 9v3l5 2v3l2 1 5 4 3 2 3 7 5 3 5 8v2h2v2h2l7 10 4 8 3 8 3 3 2 7h2l3 9h-14l-3-1-12-21-12-19-9-15-8-14-8-17-15-25-9-13-4-6-1-3-6-1-5-1v-3l-11-1-7 5h-2l1-3 5-2v-2l4-2h4z",
    fill: "#D76F24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,519)",
    d: "m0 0h8v1l-39 9-25 7-30 11-38 19-24 14-20 12-23 15-6 4-5-1-2-7 1-5 5-5 24-15 16-8 30-14 35-13 24-8 30-8z",
    fill: "#17588F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,1185)",
    d: "m0 0 3 2-3 5-1 3h-2l-2 7-3 1v5l-2 5-3 5-2 6-1 6v10l3 5-1 9-3 7-4-1v2l-3 3v4 6l-2 2 1 2-1 7-6 1-22-11-4-1 2-5 9-15 16-26 10-16 9-13 7-11z",
    fill: "#0F2D5B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1036,1445)",
    d: "m0 0h28v2h2v10l-2 5-7 4-14 1h-55l-15-1v-1h23l6-1 1-5-3-1-3-4v-2l-4 1v-2l-3-1-2-2-11-1v-1h28z",
    fill: "#18568D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,634)",
    d: "m0 0 4 2 15 27 8 13 8 16 7 12 8 12 1 5 7 11 6 11 14 24-1 2-8-13-14-24-9-15v-2l-4-2-7-11-4-6-7-18-5-5-4-7-3-4-4-1-2-1v2l-9 1-3-1v-2l-6 2-4 6-2 4-5 5-6 10v3l-3 1-7 11-5 8h-2l-2 5-8 15-8 12-4 8h-2l-1 4-6 9-6 11-6 8-4 7-7 10-12 19-10 16-7 11-2 1 2-5 7-12 14-23 14-21 11-17 16-26 13-22 7-13 7-10 10-16 14-23 12-19z",
    fill: "#EC7A27"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1410,1202)",
    d: "m0 0 2 1-2 3 5 2 4 6 8 6 5 7 1 11 2 1 3 9 3 7 1 6 4 2h-17l-7-10-10-18-14-22-2-5z",
    fill: "#D97125"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,1309)",
    d: "m0 0h39l41 1v1l-15 1-10 9-13 11-12 8-6-4-24-26z",
    fill: "#15396C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1185,1417)",
    d: "m0 0h2l1 2h8l7 2-2 6-3 2-7 7-28 11-13 4-6-17 2-2 32-12z",
    fill: "#C46421"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1545,1274)",
    d: "m0 0 10 2 5 4 5 10v7l-5 8-5 4-3 1h-8l-7-3-7-8-1-2v-9l5-8 8-5z",
    fill: "#11A4D7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 922)",
    d: "m0 0 4 2 15 25 7 11v2h-34l-14-1 8-14 9-16z",
    fill: "#C46421"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,995)",
    d: "m0 0h84l4 4 15 26h-3l-8-10-4-6-5-4-43-1-22 1-19 3-5 5-1-3 6-14z",
    fill: "#193058"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1491,931)",
    d: "m0 0 6 2 4 5 7 14 9 28 3 11v5l-2-1-1-4h-2l-1-4-4-3v-2h-2v3h-2v2h-3v14l2 22v67l-3 31-1 5h-1l1-15 2-26v-53l-3-40-5-36z",
    fill: "#D26E25"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1470,757)",
    d: "m0 0h7l6 3 6 7 1 3v7l-3 7-5 5-5 2-10-2-7-8-2-5 1-8 6-8z",
    fill: "#11A4D7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1086,1442)",
    d: "m0 0h7l2 2v4l2 1-4 4 1 1v7l-6 4-30 2h-15v-1l14-1 5-3h2l1-5 1-10h-2v-2h-14v-1l10-1z",
    fill: "#0F83B6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,850)",
    d: "m0 0 7 1 1 4h5l5-2 2 7 7 12 5 6 2 6h2l6 11 6 10 7 14 12 22 5 8 6 11 6 9 6 11 5 10h-3l-9-16-12-19-9-15-8-14-8-17-15-25-9-13-4-6-1-3-6-1-5-1v-3l-11-1-7 5h-2l1-3 5-2v-2l4-2h4z",
    fill: "#C96722"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,519)",
    d: "m0 0h8v1l-39 9-25 7-30 11-28 14h-4l-2-1 2-4 3-1 3-3 2-1v-2l41-14 30-8z",
    fill: "#159DCF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,932)",
    d: "m0 0h46l-1 5-9 16h-10l-2-8-5-4-4-1v-2l-2-1v-2l-7 1-7-2z",
    fill: "#0F2B5A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1185,1417)",
    d: "m0 0h2l1 2h8l7 2-2 6-3 2-7 7-17 7-3-1 3-5 2-1v-2h2v-4h-5l-6-2v-2l-2-1z",
    fill: "#D77025"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1084,529)",
    d: "m0 0 6 2 13 7 2 4 1 11 2 1-1 10 1 4h-5l-6-9-6-12-3-5-4-5z",
    fill: "#0E7EB2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,846)",
    d: "m0 0h7l5 3 3 3 1 5-3 7-5 5-5 1-8-5-3-5 1-8z",
    fill: "#1DB9EA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1535,1279)",
    d: "m0 0h9l1 4-1 8 4 10 2 3-3 5h-7l-8-7-3-5v-9l5-8z",
    fill: "#0F80B4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1481,911)",
    d: "m0 0 5 1 2 7 1 9-6 1h-3v7l-1 2h-2v7l3 5-1 4 1 3-5 1-4-29-1-6v-8z",
    fill: "#17548B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,550)",
    d: "m0 0 3 1-2 2h-3l-1 3-3 2v2l2-1v3l-24 13-8 5h-2l1-4 1-3h2v-2l-4 1-1-2h2v-2l-3-1 24-11z",
    fill: "#0E82B6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,621)",
    d: "m0 0h2l1 3 2 3 4 1-1-3h3v5l4 1 6 3 5 2 1 6 5-1-1-4 3 2v2l5 2 1 4 4 3 2-2 3 3v2l5 2v5h2l1 3h-2l-1 2-5-3v-2h-2v-2l-3-1-5-3h-2l-1-4-3-1-1-2-10-5-4-3h-3l-5-7-7-2-3-2v-2h-2z",
    fill: "#163769"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,1398)",
    d: "m0 0 6 2 24 10 20 7-4 1-3-1v6l-17-6-30-12 2-6z",
    fill: "#164E83"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,641)",
    d: "m0 0h6l5 5 1 2v7l-7 7-8 1-5-4-1-2v-8l5-6z",
    fill: "#0F84B8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1342,1114)",
    d: "m0 0 7 5 4 5 8 7 3 3v2l3-1 5 5v2h2l-2 9-3 7-4-5-6-9-5-8-3-8-9-12z",
    fill: "#163769"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,1292)",
    d: "m0 0 9 1 12 8-1 2-1 1v7l3 3-1 2-4 1-3-3h-2l-1-4h-4l-7-8-2-1v-2h-2v-5z",
    fill: "#0F2958"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,663)",
    d: "m0 0 3 1 10 17 8 16 7 12 5 7 1 5 7 11 6 11 14 24-1 2-8-13-14-24-9-15v-2l-4-2-7-11-4-6-7-18-5-5 1-4z",
    fill: "#E27526"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,1034)",
    d: "m0 0 3 1 4 6 7 5 3 5v3h2l6 11 4 7 3 5 2 6v2h2l3 11-3-3-7-12-5-5-15-25-7-10z",
    fill: "#154174"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,714)",
    d: "m0 0h2l-3 9-6 10-6 9-4 8h-2l-1 4-6 9-6 11-6 8-4 7-7 10-12 19-10 16-7 11-2 1 2-5 7-12 14-23 14-21 11-17 16-26 13-22z",
    fill: "#E37626"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1339,1312)",
    d: "m0 0h12l-2 4-8 8-4-1v2l-8 3-5 2-4-9-1-5z",
    fill: "#0F2D5B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1294,1363)",
    d: "m0 0 6 2 3 9-5 6-6 2-7-1-3-5 1-6 5-5z",
    fill: "#DD7A32"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1477,758)",
    d: "m0 0 5 1 7 8 1 3v7l-3 7-5 5-5 2-10-2-4-5 9 2 3-3h2l1-2 4-1-2-3v-7h3l-4-10h-2z",
    fill: "#17B7E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,616)",
    d: "m0 0 6 1 6 7-2 6-4 5-2 1h-7l-3-3-1-9 3-6z",
    fill: "#1C5B90"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,663)",
    d: "m0 0 4 2 8 3 5 2 1 4 2-4 2 2 1 6 1 3h6l-1 4 6 5 5 5v2l4 2v3h3l1 4-7 1-1-2h2v-2l-3-1-1-3-12-12-2-1v-2h-2l-2-3-3-1-1-3-5 1-4-5-3-4v-2l-4-1z",
    fill: "#163668"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,592)",
    d: "m0 0h6l2 4 1 3-2 5-11 7-5-1-2-7 1-5 5-5z",
    fill: "#163C6E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,666)",
    d: "m0 0 6 1 4 5-2 6-3 5-3 2-5-1-5-5v-8l4-4z",
    fill: "#185B92"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1545,1274)",
    d: "m0 0 10 2 5 4 5 10v7l-5 8-2 1 1-9-1-6-6-1-2-6h3v-2l-3-1-2-1v-2h-4l-1-3z",
    fill: "#20BAEA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,923)",
    d: "m0 0 2 1-5 9h-2l-3 9-5 8v8l19 1 60 1v1h-90l7-11 11-18z",
    fill: "#EA7927"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,519)",
    d: "m0 0h8v1l-39 9-25 7-14 5-2-2v-3l33-9z",
    fill: "#2FAEDA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1201,1191)",
    d: "m0 0 3 1 1 6 3 1 1 6 3 1 14 24 5 9 11 20-1 3-4-5-14-25-14-24-8-15z",
    fill: "#E17526"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,908)",
    d: "m0 0 3 1 9 16 12 19 10 15 11 20 11 18-1 2-7-10-9-15-6-11-7-11-7-10-6-11-5-7-6-12z",
    fill: "#EF7C28"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,718)",
    d: "m0 0 3 1 30 52 12 19 7 10 5 9-1 2-20-30-16-28-10-17-8-14z",
    fill: "#EF7C28"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1477,965)",
    d: "m0 0 2 2 2 4h2l2 4-2 6 3 1-1 7-1 11-3 1v8h-1l-2-29z",
    fill: "#17598F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1462,849)",
    d: "m0 0 2 2h4l4 13-1 3-6 1-5-4-2-4 1-8z",
    fill: "#12A4D7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,1234)",
    d: "m0 0 4 2 5 4 1 4-6 2h-11l-2-2v-3l-4 1v-4l12-2z",
    fill: "#102F5E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1416,1047)",
    d: "m0 0 2 3 4 4 2 8v6l-8 4-1-1-2 3 1-13z",
    fill: "#17578D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,850)",
    d: "m0 0 7 1 1 4h5l5-2 1 5-2 3h-10l-1-4-11-1-7 5h-2l1-3 5-2v-2l4-2h4z",
    fill: "#D77025"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,894)",
    d: "m0 0 3 1 4 4 2 3 6 12 1 7-3 1-2-3-1-2h-2l-3-7-2-7-1-4-2-1z",
    fill: "#F06221"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,641)",
    d: "m0 0h6l5 5 1 2v7l-7 6v-6-2l-1-4-4-2-5-2 3-3z",
    fill: "#12A2D5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,544)",
    d: "m0 0h6l-3 2h-2v2h-2v2l-3-1-3 3-1 2 2 1-12 6h-4l-2-1 2-4 3-1 3-3 2-1v-2z",
    fill: "#11A3D6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1464,761)",
    d: "m0 0 5 1 1 2-1 2h2l-1 3h-2l-2 6-3 3-1-1-1 2h-2l-1-8 4-8z",
    fill: "#0E85B9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(983,678)",
    d: "m0 0 3 1-2 4-2 6-5 5-6 9-4 7h-2l-2 5-2-1 2-5 18-28z",
    fill: "#EA7927"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,620)",
    d: "m0 0 8 1 2 5-1 9h-6l-4-6z",
    fill: "#163668"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,1309)",
    d: "m0 0h39l41 1v1l-15 1-2 1v-2l-61 1z",
    fill: "#11A4D7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,1311)",
    d: "m0 0h60l-1 2-48 1-8-1-1 2z",
    fill: "#18538A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,795)",
    d: "m0 0h2l-1 4-12 19-10 16-7 11-2 1 2-5 7-12 14-23z",
    fill: "#DE7325"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1381,1170)",
    d: "m0 0h1v12l11 20 4 2-2 3-3-1-15-27v-5z",
    fill: "#19699D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1481,1032)",
    d: "m0 0h2l-2 17h2l1 7-1 5-1 9h-2l-1 2-1-5 2-34z",
    fill: "#175B92"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,1444)",
    d: "m0 0 13 2 16 5 1 3-9-1-21-6z",
    fill: "#103261"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,604)",
    d: "m0 0 5 2 2 2 6 2 2-1 1 2h3v5l3-1 4 3v2l-5-1-11-5v-2l-4 1-6-7z",
    fill: "#163668"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,1031)",
    d: "m0 0h2l11 18 4 6v2l-4-2-5-6-1-4h-2l-3-6-3-4z",
    fill: "#1A3662"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,1398)",
    d: "m0 0 6 2 4 3-1 4-3 2-10-4 2-6z",
    fill: "#17548A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1484,1167)",
    d: "m0 0h2v2l-11 5-30 12-3 1 2-4 16-6z",
    fill: "#D16C23"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1291)",
    d: "m0 0h13l2 2h-7l-3 1-1 5h2l-1 4h-3l-5-6 1-5z",
    fill: "#1A3E70"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,519)",
    d: "m0 0h8v1l-39 9-4-1 1-2z",
    fill: "#7ACCE8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,761)",
    d: "m0 0h1v5l-7 11-4 5-4 7-5 7-2-2 12-18z",
    fill: "#E27526"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1226,1233)",
    d: "m0 0 4 4 9 17 3 5-1 3-4-5-9-16z",
    fill: "#DD7325"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,634)",
    d: "m0 0 4 2 14 25-1 2-6-9-8-14-4-1-2 3-2-1 4-6z",
    fill: "#EF7C28"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,939)",
    d: "m0 0 1 4-7 13-4 5h-6l6-7 4-5 1-2h2l2-5z",
    fill: "#2A3555"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,537)",
    d: "m0 0h3l2 4-11 4h-2v-2h-2l-1 2h-3l2-4z",
    fill: "#11A0D3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,954)",
    d: "m0 0 7 4 17 1v1l-30 1 3-5z",
    fill: "#D66F24"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,616)",
    d: "m0 0 4 1h-3l-1 4-4-1 1 3-1 6 3 5 5 1v1h-7l-3-3-1-9 3-6z",
    fill: "#2870A2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,1300)",
    d: "m0 0h2l-2 5-5 8h-2l-1 2-6-3 1-2 6-1z",
    fill: "#1D4371"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,1173)",
    d: "m0 0 1 4-2 4-3 4-5 3-2 1 2-5 5-8z",
    fill: "#103767"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,663)",
    d: "m0 0 3 1 7 12 1 7-3-3-6-7 1-4z",
    fill: "#E77827"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(947,739)",
    d: "m0 0v3l-4 8h-2l-1 4-6 9-1-3 12-20z",
    fill: "#DD7325"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1261)",
    d: "m0 0 3 1-11 17-2 1 1-5 4-7z",
    fill: "#154E81"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,709)",
    d: "m0 0 5 1 8 8-1 3-3-1v-2l-4-2-5-5z",
    fill: "#11A7DA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,697)",
    d: "m0 0 2 1-1 4-5 8h-2l-2 5-2-1 2-5z",
    fill: "#E87827"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(758,544)",
    d: "m0 0h6l-3 2h-2v2h-2v2l-3-1-3 3-5-1 1-3z",
    fill: "#0F85B9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1038)",
    d: "m0 0h2v5l-5 5h-2l-1 6h-2l1-7z",
    fill: "#154578"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,1292)",
    d: "m0 0 9 1 5 4-4 2-2-1v-2l-7 1-1-3-2-1z",
    fill: "#15386A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,1442)",
    d: "m0 0 2 2 7 1 2 3-10 3-1-2z",
    fill: "#D87025"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,668)",
    d: "m0 0 4 4-2 6-3 5-2-1 2-4-1-7z",
    fill: "#0E85B9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1354,1135)",
    d: "m0 0 3 1 2 5h2l3 6 4 7 2 1-1 3-4-5-6-9z",
    fill: "#1570A6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1276,721)",
    d: "m0 0 4 2 12 12v2l-4-2-4-5-4-2v-2h-2v-3l-3-1z",
    fill: "#11A7DA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1372)",
    d: "m0 0 5 1 5 3h3l3 3 5 2 1 3-6-2-16-9z",
    fill: "#165F95"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,1261)",
    d: "m0 0 3 1 5 8 9 1-2 2h-7l-5-4-3-5z",
    fill: "#DB7225"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,923)",
    d: "m0 0 2 1-5 9h-2l-3 9-5 3 2-4 9-15z",
    fill: "#DD7325"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1006,859)",
    d: "m0 0 3 1 6 10-1 2-2 1-5-8z",
    fill: "#CF6A23"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1191,617)",
    d: "m0 0 6 1-1 5-5 1-3-4v-2z",
    fill: "#163668"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(741,554)",
    d: "m0 0 3 1v4l-6 2-4-1 2-4z",
    fill: "#10A0D3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772,1245)",
    d: "m0 0h2l-2 5-6 10-2-4 3-3 4-7z",
    fill: "#154B7E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1385,1190)",
    d: "m0 0 3 3 5 9 4 2-2 3-3-1-7-13z",
    fill: "#1F6796"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,534)",
    d: "m0 0m-5 1 7 1v2l-8 3-2-2v-3z",
    fill: "#23AAD9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,519)",
    d: "m0 0h8v1l-18 4-5-1 4-2z",
    fill: "#F7FBFD"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1392,1196)",
    d: "m0 0 7 1-1 5-5 1z",
    fill: "#0F2C5B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1201,1191)",
    d: "m0 0 3 1 1 6 3 1 4 10-1 2-7-12-3-6z",
    fill: "#E67726"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,1031)",
    d: "m0 0h2l5 8-2 4-6-8z",
    fill: "#243C64"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,542)",
    d: "m0 0 2 1-1 2h3l1-3 3 1-1 3-6 2-1-1-5 1v-2l2-2z",
    fill: "#13ADE0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,1263)",
    d: "m0 0 3 1-7 10-4-2 5-4z",
    fill: "#1B5787"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(595,1291)",
    d: "m0 0h13l2 2h-14l-2 6-2-2 1-5z",
    fill: "#1B79AD"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1248)",
    d: "m0 0 4 2 5 9-1 3-4-5-4-7z",
    fill: "#E37626"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1181,1219)",
    d: "m0 0 3 3 8 14h-3l-8-14z",
    fill: "#156FA5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,939)",
    d: "m0 0 1 4-4 8h-3l1-4h2l2-5z",
    fill: "#293250"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,782)",
    d: "m0 0 2 1-2 5-6 8-2-2z",
    fill: "#E77827"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,1451)",
    d: "m0 0 9 2 3 3-11-1z",
    fill: "#113868"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,932)",
    d: "m0 0h10l3 2-7 2-7-2z",
    fill: "#0F2957"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1389,1266)",
    d: "m0 0 3 3-2 4h-15v-1l14-1z",
    fill: "#D77025"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1484,1167)",
    d: "m0 0h2v2l-11 5h-5l2-2z",
    fill: "#CB6922"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,577)",
    d: "m0 0 2 1-9 14-1-4 2-3h2l2-5z",
    fill: "#15659A"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1471,1113)",
    d: "m0 0 1 2 2 1h-2v2l2 1-5 8-1-3z",
    fill: "#175B91"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,709)",
    d: "m0 0 4 2 3 5-1 2-3-4h-3l-2-4z",
    fill: "#EC7A27"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,527)",
    d: "m0 0h6l-2 1v2l-9 2 1-4z",
    fill: "#42B6DF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1392,1270)",
    d: "m0 0h2l1 3-1 1h-18v-1l14-1z",
    fill: "#EF7C28"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(770,540)",
    d: "m0 0 4 1 1 3-4 1v-2h-2l-1 2h-3l2-4z",
    fill: "#0E85B9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,1380)",
    d: "m0 0 7 1 1 5-4-1v-2h-3z",
    fill: "#DB762D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,695)",
    d: "m0 0 4 1 9 6-2 1-6-3z",
    fill: "#11A4D7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,638)",
    d: "m0 0 4 1 3 4-1 2-6-4-1 2-2-1z",
    fill: "#D77025"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,517)",
    d: "m0 0 1 2h-5z",
    fill: "#FEFEFE"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,518)",
    d: "m0 0 3 1z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtc);
export default __webpack_public_path__ + "static/media/ATC.e51b2a67fbc9d4b35ca11daa9bed3f98.svg";
export { ForwardRef as ReactComponent };